// Accessibility settings script
const theme = () => {
    const html = document.documentElement;

    // Toggle settings modal
    const themeBtn = document.querySelector('.svhelp-button');
    themeBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.closest('.svhelp')?.classList.toggle('open');
    });

    // Reset to default settings
    const svhelpDefault = document.querySelector('.svhelp-default');
    svhelpDefault?.addEventListener('click', (e) => {
        e.preventDefault();

        const classesToRemove = [
            'svhelp-theme-white',
            'svhelp-theme-dark',
            'svhelp-theme-brown',
            'svhelp-theme-blue',
            'svhelp-font-size-small',
            'svhelp-font-size-medium',
            'svhelp-font-size-big',
            'svhelp-font-times',
            'svhelp-font-arial'
        ];
        html.classList.remove(...classesToRemove);

        try {
            localStorage.removeItem('svhelp-theme');
            localStorage.removeItem('svhelp-font-size');
            localStorage.removeItem('svhelp-font');
        } catch (err) {
            console.error('Error clearing localStorage:', err);
        }
    });

    // Apply theme
    document.querySelectorAll('.svhelp-item.svhelp-theme .item').forEach(themeItem => {
        themeItem.addEventListener('click', (e) => {
            e.preventDefault();

            const themeClass = e.target.dataset.svhelpClass;
            html.classList.remove(
                'svhelp-theme-white',
                'svhelp-theme-dark',
                'svhelp-theme-brown',
                'svhelp-theme-blue'
            );
            html.classList.add(themeClass);

            try {
                localStorage.setItem('svhelp-theme', themeClass);
            } catch (err) {
                console.error('Error setting localStorage for theme:', err);
            }
        });
    });

    // Apply font size
    document.querySelectorAll('.svhelp-item.svhelp-font-size .item').forEach(fontSizeItem => {
        fontSizeItem.addEventListener('click', (e) => {
            e.preventDefault();

            const fontSizeClass = e.target.dataset.svhelpClass;
            html.classList.remove(
                'svhelp-font-size-small',
                'svhelp-font-size-medium',
                'svhelp-font-size-big'
            );
            html.classList.add(fontSizeClass);

            try {
                localStorage.setItem('svhelp-font-size', fontSizeClass);
            } catch (err) {
                console.error('Error setting localStorage for font size:', err);
            }
        });
    });

    // Apply font family
    document.querySelectorAll('.svhelp-item.svhelp-font .item').forEach(fontItem => {
        fontItem.addEventListener('click', (e) => {
            e.preventDefault();

            const fontClass = e.target.dataset.svhelpClass;
            html.classList.remove('svhelp-font-times', 'svhelp-font-arial');
            html.classList.add(fontClass);

            try {
                localStorage.setItem('svhelp-font', fontClass);
            } catch (err) {
                console.error('Error setting localStorage for font:', err);
            }
        });
    });

    // Apply saved settings
    try {
        const savedTheme = localStorage.getItem('svhelp-theme');
        const savedFontSize = localStorage.getItem('svhelp-font-size');
        const savedFont = localStorage.getItem('svhelp-font');

        if (savedTheme) html.classList.add(savedTheme);
        if (savedFontSize) html.classList.add(savedFontSize);
        if (savedFont) html.classList.add(savedFont);
    } catch (err) {
        console.error('Error retrieving localStorage settings:', err);
    }
};

export default theme;
